import React, { useCallback } from 'react'
import { Button, Form, Input } from 'antd'
// 验证码
import Captcha from 'react-captcha-code'
//导入样式
import './index.scss'

import img from '@/assets/images/left-img.png'

//mobx
import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { runInAction, set } from 'mobx'

const Login = () => {

  //登录
  const { LoginStore } = useStore()

  // 验证码
  const handleClick = useCallback((captcha) => {
    runInAction(() => {
      set(LoginStore, { captcha: captcha })
    })
  }, [LoginStore])

  //验证表单input
  const changeHander = (e) => {
    runInAction(() => {
      set(LoginStore, { inputCode: e.target.value })
    })
  }
  //登录
  const onFinish = async (values) => {
    const { username, password } = values
    await LoginStore.getToken({ username, password })
  }
  // <h2>大田种植物联网监测应用云服务</h2>
  // <h3>Field plant network monitoring application cloud services</h3>
  return (
    <>
      <div className="guanli">
        <div className="public">
          <div className="title">
            <div className="juzhong">
              <span className="top2">大田种植</span>
              <span className="top3">物联网监测</span>
              <span className="top4">应用云服务</span>
            </div>
            <div className="yingwen">Field plant network monitoring application cloud services</div>
          </div>
          <div className="neirong">
            <div className="left">
              <img src={img}></img>
            </div>
            <div className="right">
              <h2>管理员登录</h2>
              <Form onFinish={onFinish} className='putBox'>
                <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: '请输入管理员账号',
                    },
                  ]}
                >
                  <Input placeholder="请输入管理员账号" size="large" />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: '请输入密码',
                    },
                  ]}
                >
                  <Input.Password placeholder="请输入密码" size="large" />
                </Form.Item>
                <Form.Item >
                  <div className='fdbj'>
                    <div className='fdbj-left'>
                      <Form.Item
                        name="code"
                        rules={[
                          { len: 4, message: '验证码4个字符', validateTrigger: 'onBlur' },
                          { required: true, message: '请输入验证码' }
                        ]}
                      >
                        <Input onChange={changeHander} placeholder="请输入验证码" maxLength={4} size="large" style={{ width: '270px' }} />
                      </Form.Item>
                    </div>
                    <div className='fdbj-right'>
                      <Captcha charNum={4} onChange={handleClick} />
                    </div>
                  </div>
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" shape="round" className="login-form-button" size="large">
                    登录
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
          <div className="bottom">版权所有  翻版必究  吉林省农业综合信息服务股份有限公司
            {/* 备案号：吉ICP-000000001号 */}
          </div>
        </div>
      </div>
    </>
  )
}
export default observer(Login)